import React, { Component } from "react";
import { Button, IconButton } from "@material-ui/core";
import PrintIcon from "@material-ui/icons/Print";
import SearchIcon from "@material-ui/icons/Search";
import GetAppIcon from "@material-ui/icons/GetApp";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import LaunchIcon from "@material-ui/icons/Launch";
import { Table, Card, Space, Tag, Input, Tooltip, Empty } from "antd";
import {
  Applicant,
  ApprovalTag,
  AddressCell,
  PaymentCell,
  RequestStatusTag,
  avatarColor,
  approvalText,
  paymentText,
  statusText,
  downloadCsv,
  matchesSearch,
} from "../certificateTableUtils";
import "../Verification/certificate-verification.css";

export default class CourseTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
    };
  }

  onActionClick(el) {
    this.props.actionClick(el);
  }

  onPrintClick(el) {
    this.props.printClick(el);
  }

  buildRows() {
    let table_data = Array.isArray(this.props.table_data)
      ? this.props.table_data
      : [];

    return table_data.filter((el) => matchesSearch(el, this.state.search));
  }

  typeFilters() {
    let seen = [];
    let table_data = Array.isArray(this.props.table_data)
      ? this.props.table_data
      : [];
    table_data.forEach((el) => {
      if (el.type_name && seen.indexOf(el.type_name) === -1) {
        seen.push(el.type_name);
      }
    });
    return seen.map((el) => ({ text: el, value: el }));
  }

  exportCsv() {
    let headers = [
      "#",
      "Sl No",
      "Certificate Type",
      "Student Name",
      "Father's Name",
      "Mother's Name",
      "Gender",
      "Address",
      "Course",
      "Semester",
      "Roll No",
      "Payment",
      "Library Status",
      "Status",
      "Timestamp",
    ];

    let rows = this.buildRows().map((el, index) => [
      index + 1,
      el.certificate_sl_no,
      el.type_name,
      el.name,
      el.father_name,
      el.mother_name,
      el.gender,
      el.address,
      el.course,
      el.semester,
      el.roll_no,
      paymentText(el),
      approvalText(el.library_status, el.library_verification_on),
      statusText(el),
      el.time_stamp,
    ]);

    downloadCsv("certificates-generated.csv", headers, rows);
  }

  render() {
    let rows = this.buildRows();
    let total = Array.isArray(this.props.table_data)
      ? this.props.table_data.length
      : 0;

    const columns = [
      {
        title: "#",
        key: "index",
        width: 56,
        fixed: "left",
        render: (text, record, index) => (
          <span className="cert-muted">{index + 1}</span>
        ),
      },
      {
        title: "Certificate No",
        dataIndex: "certificate_sl_no",
        key: "certificate_sl_no",
        width: 160,
        fixed: "left",
        sorter: (a, b) =>
          `${a.certificate_sl_no}`.localeCompare(`${b.certificate_sl_no}`),
        render: (text, el) => (
          <div>
            <div className="cert-name">{text || "—"}</div>
            {el.generated_on && (
              <div className="cert-muted">{el.generated_on}</div>
            )}
          </div>
        ),
      },
      {
        title: "Applicant",
        key: "applicant",
        width: 220,
        sorter: (a, b) => `${a.name}`.localeCompare(`${b.name}`),
        render: (text, el) => <Applicant el={el} />,
      },
      {
        title: "Certificate Type",
        key: "type",
        width: 170,
        filters: this.typeFilters(),
        onFilter: (value, el) => el.type_name === value,
        render: (text, el) => (
          <Tag
            color={avatarColor(el.type_name)}
            style={{ marginInlineEnd: 0, fontWeight: 600 }}
          >
            {el.type_name}
          </Tag>
        ),
      },
      {
        title: "Parents",
        key: "parents",
        width: 190,
        render: (text, el) => (
          <div>
            <div className="cert-muted">
              <b style={{ color: "#33415c" }}>F:</b> {el.father_name || "—"}
            </div>
            <div className="cert-muted">
              <b style={{ color: "#33415c" }}>M:</b> {el.mother_name || "—"}
            </div>
          </div>
        ),
      },
      {
        title: "Address",
        key: "address",
        width: 220,
        render: (text, el) => <AddressCell address={el.address} />,
      },
      {
        title: "Course & Semester",
        key: "course",
        width: 170,
        render: (text, el) => (
          <div>
            <div className="cert-name">{el.course || "—"}</div>
            <div className="cert-muted">
              Semester / Year: {el.semester || "—"}
            </div>
            <div className="cert-muted">Roll No: {el.roll_no || "—"}</div>
          </div>
        ),
      },
      {
        title: "Payment",
        key: "payment",
        width: 150,
        filters: [
          { text: "Paid", value: 1 },
          { text: "Not Paid", value: 0 },
        ],
        onFilter: (value, el) => (el.payment_status == 1 ? 1 : 0) === value,
        render: (text, el) => <PaymentCell el={el} />,
      },
      {
        title: "Library",
        key: "library",
        width: 150,
        render: (text, el) => (
          <ApprovalTag
            status={el.library_status}
            on={el.library_verification_on}
            by={el.library_verification_by}
          />
        ),
      },
      {
        title: "Status",
        key: "status",
        width: 150,
        render: (text, el) => <RequestStatusTag el={el} />,
      },
      {
        title: "Submitted On",
        dataIndex: "time_stamp",
        key: "time_stamp",
        width: 150,
        sorter: (a, b) => `${a.time_stamp}`.localeCompare(`${b.time_stamp}`),
        render: (text) => <span className="cert-muted">{text}</span>,
      },
      {
        title: "Action",
        key: "action",
        width: 160,
        fixed: "right",
        render: (text, el) =>
          el.status == 1 ? (
            <Space size={4}>
              <a
                target="_blank"
                href={`https://certificate.rangiacollege.ac.in/certificate-print?certificate_no=${btoa(
                  el.certificate_sl_no
                )}`}
              >
                <Button
                  size="small"
                  variant="contained"
                  disableElevation
                  className="cert-action-btn"
                  startIcon={<PrintIcon style={{ fontSize: 16 }} />}
                  style={{
                    background: "linear-gradient(120deg, #14833f, #22b258)",
                    color: "#fff",
                  }}
                >
                  Print
                </Button>
              </a>

              {this.props.actionClick && (
                <Tooltip title="Edit certificate">
                  <IconButton
                    size="small"
                    onClick={this.onActionClick.bind(this, el)}
                  >
                    <LaunchIcon style={{ fontSize: 18, color: "#2f7bf5" }} />
                  </IconButton>
                </Tooltip>
              )}
            </Space>
          ) : null,
      },
    ];

    return (
      <Card
        className="cert-card"
        styles={{ body: { padding: 16 } }}
        title={
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div
              style={{
                width: 36,
                height: 36,
                borderRadius: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#e7f8ec",
                color: "#16a34a",
              }}
            >
              <VerifiedUserIcon style={{ fontSize: 20 }} />
            </div>
            <div>
              <div className="cert-card-title">Certificates Generated</div>
              <div className="cert-card-sub">
                Certificates already issued, with their serial numbers and print
                links.
              </div>
            </div>
          </div>
        }
        extra={
          <Space>
            <span className="cert-search">
              <Input
                allowClear
                value={this.state.search}
                onChange={(e) => this.setState({ search: e.target.value })}
                placeholder="Search name, roll no, certificate no"
                prefix={
                  <SearchIcon style={{ fontSize: 16, color: "#94a3b8" }} />
                }
                style={{ width: 280 }}
              />
            </span>
            <Tooltip title="Download as CSV">
              <Button
                size="small"
                onClick={() => this.exportCsv()}
                style={{
                  minWidth: 36,
                  borderRadius: 8,
                  background: "#eaf2ff",
                  color: "#2f7bf5",
                }}
              >
                <GetAppIcon style={{ fontSize: 18 }} />
              </Button>
            </Tooltip>
          </Space>
        }
      >
        <Space size={8} style={{ marginBottom: 12 }}>
          <Tag color="blue" style={{ fontWeight: 600 }}>
            Total: {total}
          </Tag>
          {`${this.state.search}`.trim() !== "" && (
            <Tag color="purple" style={{ fontWeight: 600 }}>
              Showing: {rows.length}
            </Tag>
          )}
        </Space>

        <Table
          className="cert-table"
          size="small"
          rowKey={(el) => el.id}
          columns={columns}
          dataSource={rows}
          rowClassName={(el, index) => (index % 2 === 1 ? "cert-row-alt" : "")}
          scroll={{ x: "max-content" }}
          pagination={{
            pageSize: 25,
            showSizeChanger: true,
            pageSizeOptions: ["10", "25", "50", "100"],
            showTotal: (t, range) =>
              `${range[0]}-${range[1]} of ${t} certificates`,
          }}
          locale={{
            emptyText: <Empty description="No certificates generated yet." />,
          }}
        />
      </Card>
    );
  }
}
